import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { CreateOptionModalList } from '../../../constants';

const CreateOptionModal = ({ data, onSubmit, onCancel }) => {

    const [form, setForm] = useState({
        district: '',
        city: '',
        deliveryWeek: 0,
        description: '',
        available: 0,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(form)
        onSubmit(form);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">新增區域</h5>
                        <button className="btn-close" onClick={onCancel}></button>
                    </div>

                    <div className="custom-modal-body">
                        {/* 基本資訊 */}
                        {CreateOptionModalList.map(field => (
                            <div className="input-group mb-3" key={field.name}>
                                <span className="input-group-text">
                                    {field.label}
                                    {field.required && <span className="required-star">*</span>}
                                </span>
                                <input
                                    type={field.type}
                                    className="form-control"
                                    name={field.name}
                                    value={form[field.name]}
                                    onChange={handleChange}
                                    placeholder={field.placeholder || ""}
                                    required={field.required}
                                    pattern={field.pattern}
                                    title={field.title}
                                    max={field.max}
                                    min={field.min}
                                />
                            </div>
                        ))}
                        {/* 啟用狀態 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">啟用狀態</span>
                            <select
                                className="form-select"
                                value={form.available}
                                onChange={e => setForm(prev => ({ ...prev, available: Number(e.target.value) }))}
                            >
                                <option value="1">停用</option>
                                <option value="0">啟用</option>
                            </select>
                        </div>
                    </div>

                    <div className="custom-modal-footer">
                        <button className="btn btn-secondary" onClick={onCancel}>取消</button>
                        <button className="btn btn-gradient-primary" type="submit">儲存</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { CreateOptionModal };
